import { useEffect, useState } from "react";
import { createPatientApi } from "../api-helpers/PatientApiHelper";

export interface PatientInfo {
  /** False until the first answer (or failure). */
  loaded: boolean;
  /** Whether the patient is RPM Only; undefined when it couldn't be loaded. */
  rpmOnly?: boolean;
}

// What the appointment overlay needs to know about the patient, from their
// personal info: whether they're RPM Only (which decides whether the care
// journey shows).
// Loading it here means the overlay doesn't depend on the patient profile
// header having been visited.
export function usePatientInfo(patientId: string | undefined): PatientInfo {
  const [info, setInfo] = useState<PatientInfo>({ loaded: false });

  useEffect(() => {
    setInfo({ loaded: false });
    if (!patientId) return;

    let cancelled = false;

    const load = async () => {
      try {
        const { data } =
          await createPatientApi().patientsControllerGetPatientPersonalInfo(patientId);
        if (!cancelled) {
          setInfo({
            loaded: true,
            rpmOnly: typeof data?.rpmOnly === "boolean" ? data.rpmOnly : undefined,
          });
        }
      } catch (error) {
        console.error("Error loading the patient's details:", error);
        if (!cancelled) setInfo({ loaded: true });
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [patientId]);

  return info;
}
